import Axios from "axios";
import {
    SET_INV_LC_RECEIVE_LIST,
    UNSET_INV_LC_RECEIVE_LIST,
} from "@/store/mutation-types.js";
import {
    saveUpdateInvLcReceive,
    lcReceiveRecord,
    lcReceiveById,
} from "@/store/api";

const state = {
    getInvLcReceiveList: [],
}

const getters = {
    getInvLcReceiveList(state) {
        return state.getInvLcReceiveList;
    },
}

const mutations = {
    [SET_INV_LC_RECEIVE_LIST](state, data) {
        state.getInvLcReceiveList = data;
    },
    [UNSET_INV_LC_RECEIVE_LIST](state) {
        state.getInvLcReceiveList = [];
    },
}

const actions = {

    saveUpdateInvLcReceive({ commit }, data) {
        commit("SET_LOADING", { color: "primary" })
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateInvLcReceive, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                })
        })
    },

    getInvLcReceiveList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(lcReceiveRecord, data)
                .then(function (response) {
                    commit('SET_INV_LC_RECEIVE_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_INV_LC_RECEIVE_LIST');
                    reject(error);
                })
                .then(() => {
                    
                })
        })
    },

    getInvLcReceiveById({ commit }, id) {
        const getInvLcReceiveById = `${lcReceiveById}/${id}`;
        return new Promise((resolve, reject) => {
            Axios.get(getInvLcReceiveById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                });
            });
    },

}

export default {
    state,
    getters,
    mutations,
    actions,
}